var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.authenticated
    ? _c("body", { staticClass: "color-background-stage font-medium" }, [
        _c("div", { staticClass: "grid-app-container" }, [
          _c(
            "div",
            { staticClass: "irs-header grid-header-container shadow-large" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("label", { staticClass: "irs-header-title" }, [
                _vm._v("Platform Reports")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "contact-us-icon",
                  on: {
                    click: function($event) {
                      return _vm.goTo("mailto:", false)
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "envelope" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "contact-us-label",
                  on: {
                    click: function($event) {
                      return _vm.goTo("mailto:", false)
                    }
                  }
                },
                [_c("div", [_vm._v("Contact Us")])]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "irs-sidebar-content-container" }, [
            _c(
              "div",
              {
                staticClass: "irs-sidebar",
                class: {
                  "color-background-container": !_vm.sidebar,
                  "": _vm.sidebar
                }
              },
              [
                _c(
                  "router-link",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    attrs: { to: { name: "Home" } }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "irs-sidebar-home" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "irs-sidebar-icon",
                            on: {
                              click: function($event) {
                                _vm.sidebar = !_vm.sidebar
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", { attrs: { icon: "home" } })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sidebar,
                                  expression: "sidebar"
                                }
                              ]
                            },
                            [_vm._v("Home")]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("router-link", { attrs: { to: { name: "Products" } } }, [
                  _c(
                    "div",
                    { staticClass: "irs-sidebar-product" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "irs-sidebar-icon",
                          on: {
                            click: function($event) {
                              _vm.sidebar = !_vm.sidebar
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "server" } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sidebar,
                                expression: "sidebar"
                              }
                            ]
                          },
                          [_vm._v("Platforms Instances")]
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("router-link", { attrs: { to: { name: "Aggregated" } } }, [
                  _c(
                    "div",
                    { staticClass: "irs-sidebar-aggregate" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "irs-sidebar-icon",
                          on: {
                            click: function($event) {
                              _vm.sidebar = !_vm.sidebar
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "calculator" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sidebar,
                                expression: "sidebar"
                              }
                            ]
                          },
                          [_vm._v("Aggregated Reports")]
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("router-link", { attrs: { to: { name: "Queries" } } }, [
                  _c(
                    "div",
                    { staticClass: "irs-sidebar-search" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "irs-sidebar-icon",
                          on: {
                            click: function($event) {
                              _vm.sidebar = !_vm.sidebar
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "database" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sidebar,
                                expression: "sidebar"
                              }
                            ]
                          },
                          [_vm._v("XPath Reports")]
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("router-link", { attrs: { to: { name: "Reports" } } }, [
                  _c(
                    "div",
                    { staticClass: "irs-sidebar-reports" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "irs-sidebar-icon",
                          on: {
                            click: function($event) {
                              _vm.sidebar = !_vm.sidebar
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "history" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sidebar,
                                expression: "sidebar"
                              }
                            ]
                          },
                          [_vm._v("CEP Report Log")]
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasAnyAuthority("cep-revenue"),
                        expression: "hasAnyAuthority('cep-revenue')"
                      }
                    ],
                    attrs: { to: { name: "Revenue" } }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "irs-sidebar-reports" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "irs-sidebar-icon",
                            on: {
                              click: function($event) {
                                _vm.sidebar = !_vm.sidebar
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "money-bill-alt" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sidebar,
                                  expression: "sidebar"
                                }
                              ]
                            },
                            [_vm._v("Revenue")]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasAnyAuthority("cep-revenue"),
                        expression: "hasAnyAuthority('cep-revenue')"
                      }
                    ],
                    attrs: { to: { name: "Uploading" } }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "irs-sidebar-uploading" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "irs-sidebar-icon",
                            on: {
                              click: function($event) {
                                _vm.sidebar = !_vm.sidebar
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "file-upload" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sidebar,
                                  expression: "sidebar"
                                }
                              ]
                            },
                            [_vm._v("File Uploading")]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { to: { name: "LogsComponent" } } },
                  [
                    _vm.hasAnyAuthority("cep-admins")
                      ? _c(
                          "div",
                          { staticClass: "irs-sidebar-admin" },
                          [
                            _c(
                              "div",
                              { staticClass: "irs-sidebar-icon" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "hdd" },
                                  on: {
                                    click: function($event) {
                                      _vm.sidebar = !_vm.sidebar
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("transition", { attrs: { name: "fade" } }, [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.sidebar,
                                      expression: "sidebar"
                                    }
                                  ]
                                },
                                [_vm._v("Administration")]
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "irs-content" }, [
              _c("main", { attrs: { role: "main" } }, [_c("router-view")], 1)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "irs-footer" }, [_c("content-footer")], 1)
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "irs-header-img" }, [
      _c("img", {
        staticClass: "panel-logo",
        attrs: { src: require("./assets/panel-logo.png") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }